import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import {
    createOverallFilterPosition,
    createFilterPosition,
    isOverallFilterPosition,
    createFilterPositionByKeyAndPositions,
} from './filter-position-interface';
import InputRadio from 'components/atoms/inputs/input-radio';

class FilterByPositions extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('PlayerPositionsFilter', value));
    }

    getTabView(params) {
        const {value, title, isChecked} = params;
        return (
            <label className="tabs-chk" key={value.getKey()}>
                <InputRadio value={value} checked={isChecked} onChange={::this.onChange} />
                <span>{title}</span>
            </label>
        );
    }

    getPositionTabs(positions) {
        const {playersFilter} = this.props;

        const tabs = [];
        positions.map((position) => {
            if (position.key === 'FLEX') {
                return;
            }

            const filterPosition = createFilterPosition(position);

            tabs.push(
                this.getTabView({
                    value: filterPosition,
                    title: position.key,
                    isChecked: playersFilter.playerPosition.isKeyEqual(filterPosition.getKey()),
                }),
            );
        });

        return tabs;
    }

    getMlbPositionTabs(positions) {
        const {playersFilter} = this.props;

        const hitterPositions = positions.filter((position) => position.key !== 'P');
        const filterPosition = createFilterPositionByKeyAndPositions('H', hitterPositions);

        const hitterTabView = this.getTabView({
            value: filterPosition,
            title: filterPosition.getKey(),
            isChecked: playersFilter.playerPosition.isKeyEqual(filterPosition.getKey()),
        });

        const tabs = [];
        positions.map((position) => {
            if (position.key === 'FLEX') {
                return;
            }

            const filterPosition = createFilterPosition(position);

            tabs.push(
                this.getTabView({
                    value: filterPosition,
                    title: position.key,
                    isChecked: playersFilter.playerPosition.isKeyEqual(filterPosition.getKey()),
                }),
            );

            if (position.key === 'P') {
                tabs.push(hitterTabView);
            }
        });

        return tabs;
    }

    getTabs() {
        const {sportConfig, playersFilter} = this.props;

        const positions = sportConfig.getFilter('positions', []);

        const tabAll = this.getTabView({
            value: createOverallFilterPosition(),
            title: 'All',
            isChecked: isOverallFilterPosition(playersFilter.playerPosition),
        });

        return sportConfig.isSportMlb() && !sportConfig.isGameTypeTiers()
            ? [tabAll, ...this.getMlbPositionTabs(positions)]
            : [tabAll, ...this.getPositionTabs(positions)];
    }

    render() {
        const {sportConfig, simpleMode, enableRounded} = this.props;

        if (!sportConfig.usePositionFilter()) {
            return false;
        }

        const tabs = this.getTabs();

        if (simpleMode) {
            return <div className={`tabs-chk-holder${enableRounded ? ' rounded-mode' : ''}`}>{tabs}</div>;
        }

        return (
            <div className="filters-cell position-cell">
                <div className="filter-group">
                    <strong className="filter-title">Select Positions</strong>
                    <div className="tabs-chk-holder">{tabs}</div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, playersData} = state;

    return {
        playersFilter: playersData.filters,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(FilterByPositions);
